import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white dark:bg-[#0c1427]" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8" }
const _hoisted_3 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8"
}
const _hoisted_4 = {
  class: "bg-white dark:bg-[#1a2332] rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-800 hover:shadow-xl transition-all duration-500 hover:scale-[1.02] hover:-translate-y-1 animate-fade-in-up",
  style: {"animation-delay":"0.1s"}
}
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "text-sm font-medium text-gray-600 dark:text-gray-400 mb-1" }
const _hoisted_7 = { class: "text-3xl font-bold text-gray-900 dark:text-white" }
const _hoisted_8 = {
  class: "bg-white dark:bg-[#1a2332] rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-800 hover:shadow-xl transition-all duration-500 hover:scale-[1.02] hover:-translate-y-1 animate-fade-in-up",
  style: {"animation-delay":"0.2s"}
}
const _hoisted_9 = { class: "flex items-center justify-between" }
const _hoisted_10 = { class: "text-sm font-medium text-gray-600 dark:text-gray-400 mb-1" }
const _hoisted_11 = { class: "text-3xl font-bold text-gray-900 dark:text-white" }
const _hoisted_12 = {
  class: "bg-white dark:bg-[#1a2332] rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-800 hover:shadow-xl transition-all duration-500 hover:scale-[1.02] hover:-translate-y-1 animate-fade-in-up",
  style: {"animation-delay":"0.3s"}
}
const _hoisted_13 = { class: "flex items-center justify-between" }
const _hoisted_14 = { class: "text-sm font-medium text-gray-600 dark:text-gray-400 mb-1" }
const _hoisted_15 = { class: "space-y-2 mt-2" }
const _hoisted_16 = { class: "flex items-center gap-4" }
const _hoisted_17 = { class: "text-sm font-medium text-gray-700 dark:text-gray-300" }
const _hoisted_18 = { class: "text-lg font-bold text-green-600 dark:text-green-400" }
const _hoisted_19 = { class: "flex items-center gap-4" }
const _hoisted_20 = { class: "text-sm font-medium text-gray-700 dark:text-gray-300" }
const _hoisted_21 = { class: "text-lg font-bold text-gray-500 dark:text-gray-400" }
const _hoisted_22 = { class: "sticky top-0 z-[5] backdrop-blur-xl bg-white/70 dark:bg-[#0c1427]/70 animate-fade-in-down" }
const _hoisted_23 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" }
const _hoisted_24 = { class: "flex flex-col-reverse sm:flex-row items-center justify-between gap-4" }
const _hoisted_25 = { class: "w-full sm:w-auto" }
const _hoisted_26 = { class: "relative group" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = { class: "font-semibold" }
const _hoisted_29 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_30 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_31 = { class: "mt-4 text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_32 = {
  key: 1,
  class: "text-center py-20"
}
const _hoisted_33 = { class: "text-lg font-semibold text-gray-900 dark:text-white mb-2" }
const _hoisted_34 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_35 = {
  key: 2,
  class: "overflow-hidden rounded-3xl shadow-xl animate-fade-in-up bg-white dark:bg-[#1a2332] border border-gray-200 dark:border-gray-700",
  style: {"animation-delay":"0.6s"}
}
const _hoisted_36 = { class: "overflow-x-auto custom-scrollbar mobile-table-scroll" }
const _hoisted_37 = ["dir"]
const _hoisted_38 = { style: {"background":"linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)"} }
const _hoisted_39 = { class: "sticky top-0 z-10 px-6 py-4 text-center font-semibold text-xs uppercase tracking-wider text-white" }
const _hoisted_40 = { class: "sticky top-0 z-10 px-6 py-4 text-center font-semibold text-xs uppercase tracking-wider text-white" }
const _hoisted_41 = { class: "sticky top-0 z-10 px-6 py-4 text-center font-semibold text-xs uppercase tracking-wider text-white" }
const _hoisted_42 = { class: "sticky top-0 z-10 px-6 py-4 text-center font-semibold text-xs uppercase tracking-wider text-white" }
const _hoisted_43 = { class: "divide-y divide-gray-200 dark:divide-gray-600" }
const _hoisted_44 = { class: "px-6 py-4 whitespace-nowrap text-center" }
const _hoisted_45 = { class: "flex items-center justify-center" }
const _hoisted_46 = ["src", "alt"]
const _hoisted_47 = { class: "min-w-[120px]" }
const _hoisted_48 = { class: "text-sm font-semibold text-gray-900 dark:text-white truncate" }
const _hoisted_49 = { class: "px-6 py-4 whitespace-nowrap text-center" }
const _hoisted_50 = { class: "flex items-center justify-center gap-2 ltr:flex-row rtl:flex-row-reverse" }
const _hoisted_51 = { class: "text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_52 = { class: "px-6 py-4 whitespace-nowrap text-center" }
const _hoisted_53 = { class: "px-6 py-4 whitespace-nowrap text-center" }
const _hoisted_54 = { class: "flex items-center justify-center gap-2 ltr:flex-row rtl:flex-row-reverse" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  class: "flex items-center justify-between",
  style: {"align-items":"center"}
}
const _hoisted_58 = { class: "flex items-center gap-3" }
const _hoisted_59 = {
  class: "text-xl font-bold text-white",
  style: {"margin":"0"}
}
const _hoisted_60 = { class: "flex items-center gap-4 pb-6 border-b border-gray-200 dark:border-gray-600" }
const _hoisted_61 = {
  key: 0,
  class: "w-20 h-20 rounded-2xl overflow-hidden shadow-lg"
}
const _hoisted_62 = ["src", "alt"]
const _hoisted_63 = { class: "text-2xl font-bold text-gray-900 dark:text-white" }
const _hoisted_64 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_65 = { class: "rounded-xl p-4 bg-gray-50 dark:bg-gray-700" }
const _hoisted_66 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_67 = { class: "text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400" }
const _hoisted_68 = { class: "text-sm font-medium text-gray-900 dark:text-gray-100" }
const _hoisted_69 = { class: "rounded-xl p-4 bg-gray-50 dark:bg-gray-700" }
const _hoisted_70 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_71 = { class: "text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400" }
const _hoisted_72 = { class: "text-sm font-medium text-gray-900 dark:text-gray-100" }
const _hoisted_73 = { class: "rounded-xl p-4 bg-gray-50 dark:bg-gray-700" }
const _hoisted_74 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_75 = { class: "text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400" }
const _hoisted_76 = { class: "space-y-4" }
const _hoisted_77 = { class: "rounded-xl p-4 bg-gray-50 dark:bg-gray-700" }
const _hoisted_78 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_79 = { class: "text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400" }
const _hoisted_80 = { class: "text-sm font-medium text-gray-900 dark:text-gray-100" }
const _hoisted_81 = { class: "rounded-xl p-4 bg-gray-50 dark:bg-gray-700" }
const _hoisted_82 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_83 = { class: "text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-400" }
const _hoisted_84 = { class: "text-sm font-medium text-gray-900 dark:text-gray-100" }
const _hoisted_85 = { class: "px-6 py-4 border-t border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 flex items-center justify-between" }
const _hoisted_86 = {
  class: "flex items-center justify-between",
  style: {"align-items":"center"}
}
const _hoisted_87 = { class: "flex items-center gap-3" }
const _hoisted_88 = {
  class: "text-xl font-bold text-white",
  style: {"margin":"0"}
}
const _hoisted_89 = { class: "group" }
const _hoisted_90 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_91 = ["placeholder"]
const _hoisted_92 = { class: "group" }
const _hoisted_93 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_94 = ["placeholder"]
const _hoisted_95 = { class: "group" }
const _hoisted_96 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_97 = { class: "relative" }
const _hoisted_98 = { value: "active" }
const _hoisted_99 = { value: "deactive" }
const _hoisted_100 = { class: "group" }
const _hoisted_101 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_102 = { class: "px-6 py-4 border-t border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 flex items-center justify-between gap-3" }
const _hoisted_103 = ["disabled"]
const _hoisted_104 = { key: 0 }
const _hoisted_105 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_106 = {
  class: "flex items-center justify-between",
  style: {"align-items":"center"}
}
const _hoisted_107 = { class: "flex items-center gap-3" }
const _hoisted_108 = {
  class: "text-xl font-bold text-white",
  style: {"margin":"0"}
}
const _hoisted_109 = { class: "group" }
const _hoisted_110 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_111 = ["placeholder"]
const _hoisted_112 = { class: "group" }
const _hoisted_113 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_114 = ["placeholder"]
const _hoisted_115 = { class: "group" }
const _hoisted_116 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_117 = { class: "relative" }
const _hoisted_118 = { value: "active" }
const _hoisted_119 = { value: "deactive" }
const _hoisted_120 = { class: "group" }
const _hoisted_121 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_122 = { class: "px-6 py-4 border-t border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 flex items-center justify-between gap-3" }
const _hoisted_123 = ["disabled"]
const _hoisted_124 = { key: 0 }
const _hoisted_125 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_126 = {
  key: 3,
  class: "fixed inset-0 flex items-center justify-center z-50 p-4"
}
const _hoisted_127 = { class: "relative w-full max-w-md transform transition-all duration-300 scale-100 opacity-100" }
const _hoisted_128 = { class: "bg-white dark:bg-[#1c1c1e] rounded-3xl shadow-2xl overflow-hidden" }
const _hoisted_129 = {
  class: "px-6 py-6",
  style: {"background":"linear-gradient(135deg, #ef4444 0%, #dc2626 100%)"}
}
const _hoisted_130 = { class: "flex items-center justify-between" }
const _hoisted_131 = { class: "flex items-center gap-3" }
const _hoisted_132 = { class: "text-xl font-bold text-white" }
const _hoisted_133 = { class: "p-8" }
const _hoisted_134 = { class: "text-center mb-6" }
const _hoisted_135 = { class: "text-lg font-semibold text-gray-900 dark:text-white mb-2" }
const _hoisted_136 = { class: "text-base text-gray-700 dark:text-gray-300 mb-2" }
const _hoisted_137 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_138 = { class: "px-6 py-4 bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-600 flex justify-between gap-3" }
const _hoisted_139 = ["disabled"]
const _hoisted_140 = {
  key: 0,
  class: "w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"
}
const _hoisted_141 = {
  key: 1,
  class: "flex items-center gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!$setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString($setup.directT('contacts.totalContacts')), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString($setup.contacts.length), 1)
                ]),
                _cache[43] || (_cache[43] = _createElementVNode("div", {
                  class: "w-12 h-12 rounded-full flex items-center justify-center animate-bounce-in",
                  style: {"background":"linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)","animation-delay":"0.3s"}
                }, [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-[24px] text-white" }, " group ")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString($setup.directT('contacts.newContactsLast7Days')), 1),
                  _createElementVNode("p", _hoisted_11, _toDisplayString($setup.newContactsCount), 1)
                ]),
                _cache[44] || (_cache[44] = _createElementVNode("div", {
                  class: "w-12 h-12 rounded-full flex items-center justify-center animate-bounce-in",
                  style: {"background":"linear-gradient(135deg, #10b981 0%, #06b6d4 100%)","animation-delay":"0.4s"}
                }, [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-[24px] text-white" }, " person_add ")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_14, _toDisplayString($setup.directT('contacts.statusBreakdown')), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString($setup.directT('contacts.active')) + ":", 1),
                      _createElementVNode("span", _hoisted_18, _toDisplayString($setup.activeContactsCount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString($setup.directT('contacts.deactive')) + ":", 1),
                      _createElementVNode("span", _hoisted_21, _toDisplayString($setup.inactiveContactsCount), 1)
                    ])
                  ])
                ]),
                _cache[45] || (_cache[45] = _createElementVNode("div", {
                  class: "w-12 h-12 rounded-full flex items-center justify-center animate-bounce-in",
                  style: {"background":"linear-gradient(135deg, #f59e0b 0%, #ec4899 100%)","animation-delay":"0.5s"}
                }, [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-[24px] text-white" }, " pie_chart ")
                ], -1))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", {
                class: _normalizeClass(["absolute ltr:left-4 rtl:right-4 top-1/2 -translate-y-1/2 transition-all duration-300 pointer-events-none", $setup.searchQuery ? 'opacity-0 ltr:-translate-x-2 rtl:translate-x-2' : 'opacity-100'])
              }, _cache[46] || (_cache[46] = [
                _createElementVNode("i", {
                  class: "material-symbols-outlined !text-[22px]",
                  style: {"color":"#9ca3af"}
                }, "search", -1)
              ]), 2),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
                placeholder: $setup.directT('contacts.searchContact'),
                class: "w-full sm:w-[380px] h-[48px] ltr:pl-12 ltr:pr-12 rtl:pr-12 rtl:pl-12 rounded-full border-2 transition-all duration-300 text-sm sm:text-base font-medium shadow-md hover:shadow-lg focus:shadow-xl outline-none placeholder:text-gray-400 dark:placeholder:text-gray-500 bg-white dark:bg-[#1a2332] text-gray-900 dark:text-white border-gray-200 dark:border-[#2a3441] focus:border-purple-500 dark:focus:border-purple-400"
              }, null, 8, _hoisted_27), [
                [_vModelText, $setup.searchQuery]
              ]),
              ($setup.searchQuery)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "absolute ltr:right-3 rtl:left-3 top-1/2 -translate-y-1/2 cursor-pointer transition-all duration-200 hover:scale-110",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.searchQuery = ''))
                  }, [
                    _createElementVNode("div", {
                      class: "w-7 h-7 rounded-full flex items-center justify-center transition-colors duration-200",
                      style: {"background-color":"rgba(139, 92, 246, 0.1)"},
                      onMouseover: _cache[1] || (_cache[1] = ($event: any) => ($event.currentTarget.style.backgroundColor = 'rgba(139, 92, 246, 0.2)')),
                      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => ($event.currentTarget.style.backgroundColor = 'rgba(139, 92, 246, 0.1)'))
                    }, _cache[47] || (_cache[47] = [
                      _createElementVNode("i", {
                        class: "material-symbols-outlined !text-[18px]",
                        style: {"color":"#8b5cf6"}
                      }, "close", -1)
                    ]), 32)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "w-full sm:w-auto group flex items-center justify-center gap-2 px-4 sm:px-6 py-3 rounded-full font-medium text-sm sm:text-base transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-lg",
            style: {"background":"linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)","color":"#ffffff"},
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.openAddContactModal && $setup.openAddContactModal(...args)))
          }, [
            _cache[48] || (_cache[48] = _createElementVNode("div", {
              class: "w-8 h-8 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:rotate-180",
              style: {"background-color":"rgba(255, 255, 255, 0.2)"}
            }, [
              _createElementVNode("i", {
                class: "material-symbols-outlined !text-[20px]",
                style: {"color":"#ffffff"}
              }, " add ")
            ], -1)),
            _createElementVNode("span", _hoisted_28, _toDisplayString($setup.directT('contacts.addNewContact')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _cache[49] || (_cache[49] = _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("div", {
                class: "w-16 h-16 rounded-full border-4 animate-spin",
                style: {"border-color":"#e5e7eb","border-top-color":"#8b5cf6"}
              })
            ], -1)),
            _createElementVNode("p", _hoisted_31, _toDisplayString($setup.directT('common.loading')), 1)
          ]))
        : ($setup.filteredContacts.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _cache[50] || (_cache[50] = _createElementVNode("div", {
                class: "inline-flex items-center justify-center w-20 h-20 rounded-full mb-4",
                style: {"background-color":"#f3f4f6"}
              }, [
                _createElementVNode("i", {
                  class: "material-symbols-outlined !text-[40px]",
                  style: {"color":"#9ca3af"}
                }, "person_off")
              ], -1)),
              _createElementVNode("h3", _hoisted_33, _toDisplayString($setup.searchQuery ? $setup.directT('contacts.noContactsFound') : $setup.directT('contacts.noContactsFound')), 1),
              _createElementVNode("p", _hoisted_34, _toDisplayString($setup.searchQuery ? $setup.directT('contacts.tryAdjustingSearch') : $setup.directT('contacts.addFirstContact')), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("table", {
                  class: "w-full mobile-table",
                  dir: $setup.isRTL ? 'rtl' : 'ltr'
                }, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_38, [
                      _createElementVNode("th", _hoisted_39, _toDisplayString($setup.directT('contacts.name')), 1),
                      _createElementVNode("th", _hoisted_40, _toDisplayString($setup.directT('contacts.phone')), 1),
                      _createElementVNode("th", _hoisted_41, _toDisplayString($setup.directT('contacts.status')), 1),
                      _createElementVNode("th", _hoisted_42, _toDisplayString($setup.directT('contacts.action')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredContacts, (contact) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: contact.id,
                        class: "group hover:bg-gray-50 dark:hover:bg-[#253344] transition-all duration-200 bg-white dark:bg-[#1a2332]"
                      }, [
                        _createElementVNode("td", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            (contact.profile_picture_link)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "w-10 h-10 rounded-full overflow-hidden flex-shrink-0",
                                  style: _normalizeStyle({ marginRight: $setup.isRTL ? '0' : '0.75rem', marginLeft: $setup.isRTL ? '0.75rem' : '0' })
                                }, [
                                  _createElementVNode("img", {
                                    src: contact.profile_picture_link,
                                    alt: contact.name,
                                    class: "w-full h-full object-cover",
                                    onError: _cache[5] || (_cache[5] = ($event: any) => {$event.target.style.display = 'none'; $event.target.nextElementSibling.style.display = 'flex'})
                                  }, null, 40, _hoisted_46),
                                  _createElementVNode("div", {
                                    class: "w-10 h-10 rounded-full flex items-center justify-center font-semibold text-white",
                                    style: _normalizeStyle({ backgroundColor: $setup.getAvatarColor(contact.name), display: 'none' })
                                  }, _toDisplayString($setup.getInitials(contact.name)), 5)
                                ], 4))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "w-10 h-10 rounded-full flex items-center justify-center font-semibold text-white flex-shrink-0",
                                  style: _normalizeStyle({ backgroundColor: $setup.getAvatarColor(contact.name), marginRight: $setup.isRTL ? '0' : '0.75rem', marginLeft: $setup.isRTL ? '0.75rem' : '0' })
                                }, _toDisplayString($setup.getInitials(contact.name)), 5)),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("p", _hoisted_48, _toDisplayString(contact.name), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _cache[51] || (_cache[51] = _createElementVNode("i", { class: "material-symbols-outlined !text-[16px] text-gray-400 dark:text-gray-500" }, "phone", -1)),
                            _createElementVNode("span", _hoisted_51, _toDisplayString(contact.phone || $setup.directT('common.notAvailable')), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_52, [
                          _createElementVNode("span", {
                            class: "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium",
                            style: _normalizeStyle($setup.getStatusStyle(contact.status))
                          }, _toDisplayString(contact.status === 'active' ? $setup.directT('contacts.active') : $setup.directT('contacts.deactive')), 5)
                        ]),
                        _createElementVNode("td", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 hover:scale-110",
                              style: {"background-color":"#ede9fe"},
                              onClick: ($event: any) => ($setup.openViewPopup(contact)),
                              onMouseover: _cache[6] || (_cache[6] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#ddd6fe')),
                              onMouseleave: _cache[7] || (_cache[7] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#ede9fe'))
                            }, _cache[52] || (_cache[52] = [
                              _createElementVNode("i", {
                                class: "material-symbols-outlined !text-[18px]",
                                style: {"color":"#7c3aed"}
                              }, " visibility ", -1)
                            ]), 40, _hoisted_55),
                            _createElementVNode("button", {
                              type: "button",
                              class: "w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 hover:scale-110",
                              style: {"background-color":"#fee2e2"},
                              onClick: ($event: any) => ($setup.deleteContact(contact)),
                              onMouseover: _cache[8] || (_cache[8] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#fecaca')),
                              onMouseleave: _cache[9] || (_cache[9] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#fee2e2'))
                            }, _cache[53] || (_cache[53] = [
                              _createElementVNode("i", {
                                class: "material-symbols-outlined !text-[18px]",
                                style: {"color":"#dc2626"}
                              }, " delete ", -1)
                            ]), 40, _hoisted_56)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ], 8, _hoisted_37)
              ])
            ]))
    ]),
    ($setup.showViewPopup && $setup.selectedContact)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'view-contact-popup view-contact-modal fixed transition-all inset-0 z-[10000]',
        { active: $setup.showViewPopup },
        $setup.isMobile ? 'top-[80px]' : 'overflow-x-hidden overflow-y-auto p-4'
      ])
        }, [
          _createElementVNode("div", {
            class: "absolute inset-0 bg-black/40 backdrop-blur-sm",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.closeViewPopup && $setup.closeViewPopup(...args)))
          }),
          _createElementVNode("div", {
            class: _normalizeClass($setup.isMobile ? 'relative w-full h-full' : 'popup-dialog flex transition-all max-w-[550px] min-h-full items-center mx-auto relative')
          }, [
            _createElementVNode("div", {
              class: _normalizeClass($setup.isMobile ? 'modal-content w-full h-full flex flex-col rounded-3xl bg-white dark:bg-[#1c1c1e] overflow-hidden' : 'modal-content w-full bg-white dark:bg-[#1c1c1e] rounded-3xl shadow-2xl overflow-hidden transform transition-all duration-300 scale-100 opacity-100')
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["relative px-6 py-5", $setup.isMobile ? 'rounded-t-3xl' : '']),
                style: {"background":"linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)"}
              }, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "w-10 h-10 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-[24px] text-white" }, " person ")
                    ], -1)),
                    _createElementVNode("h2", _hoisted_59, _toDisplayString($setup.directT('contacts.viewContact')), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.closeViewPopup && $setup.closeViewPopup(...args))),
                    class: "w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 transition-all duration-200 flex items-center justify-center group",
                    style: {"border":"none","cursor":"pointer"}
                  }, _cache[55] || (_cache[55] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-white group-hover:rotate-90 transition-transform duration-200" }, " close ", -1)
                  ]))
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["p-6 space-y-6 custom-scrollbar", $setup.isMobile ? 'flex-1 overflow-y-auto' : 'max-h-[60vh] overflow-y-auto'])
              }, [
                _createElementVNode("div", _hoisted_60, [
                  ($setup.selectedContact?.profile_picture_link)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _createElementVNode("img", {
                          src: $setup.selectedContact.profile_picture_link,
                          alt: $setup.selectedContact.name,
                          class: "w-full h-full object-cover",
                          onError: _cache[12] || (_cache[12] = ($event: any) => {$event.target.style.display = 'none'; $event.target.nextElementSibling.style.display = 'flex'})
                        }, null, 40, _hoisted_62),
                        _createElementVNode("div", {
                          class: "w-20 h-20 rounded-2xl flex items-center justify-center font-bold text-white text-2xl shadow-lg",
                          style: _normalizeStyle({ backgroundColor: $setup.getAvatarColor($setup.selectedContact?.name || ''), display: 'none' })
                        }, _toDisplayString($setup.getInitials($setup.selectedContact?.name || '')), 5)
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "w-20 h-20 rounded-2xl flex items-center justify-center font-bold text-white text-2xl shadow-lg",
                        style: _normalizeStyle({ backgroundColor: $setup.getAvatarColor($setup.selectedContact?.name || '') })
                      }, _toDisplayString($setup.getInitials($setup.selectedContact?.name || '')), 5)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_63, _toDisplayString($setup.selectedContact?.name || $setup.directT('common.notAvailable')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _cache[56] || (_cache[56] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "phone", -1)),
                      _createElementVNode("span", _hoisted_67, _toDisplayString($setup.directT('contacts.phone')), 1)
                    ]),
                    _createElementVNode("p", _hoisted_68, _toDisplayString($setup.selectedContact?.phone || $setup.directT('common.notAvailable')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _cache[57] || (_cache[57] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "business", -1)),
                      _createElementVNode("span", _hoisted_71, _toDisplayString($setup.directT('contacts.company')), 1)
                    ]),
                    _createElementVNode("p", _hoisted_72, _toDisplayString($setup.selectedContact?.company || $setup.directT('common.notAvailable')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _cache[58] || (_cache[58] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "toggle_on", -1)),
                      _createElementVNode("span", _hoisted_75, _toDisplayString($setup.directT('contacts.status')), 1)
                    ]),
                    _createElementVNode("span", {
                      class: "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium",
                      style: _normalizeStyle($setup.getStatusStyle($setup.selectedContact?.status || 'inactive'))
                    }, _toDisplayString($setup.selectedContact?.status === 'active' ? $setup.directT('contacts.active') : $setup.directT('contacts.deactive')), 5)
                  ])
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _cache[59] || (_cache[59] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "calendar_today", -1)),
                      _createElementVNode("span", _hoisted_79, _toDisplayString($setup.directT('contacts.created')), 1)
                    ]),
                    _createElementVNode("p", _hoisted_80, _toDisplayString($setup.formatDate($setup.selectedContact?.created_at)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _cache[60] || (_cache[60] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "schedule", -1)),
                      _createElementVNode("span", _hoisted_83, _toDisplayString($setup.directT('contacts.lastContact')), 1)
                    ]),
                    _createElementVNode("p", _hoisted_84, _toDisplayString($setup.formatDate($setup.selectedContact?.last_contact)), 1)
                  ])
                ])
              ], 2),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[13] || (_cache[13] = () => { $setup.openEditModal($setup.selectedContact); $setup.closeViewPopup(); }),
                  class: "px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 hover:shadow-lg",
                  style: {"background":"linear-gradient(135deg, #f093fb 0%, #f5576c 100%)","color":"#ffffff"}
                }, [
                  _cache[61] || (_cache[61] = _createElementVNode("i", { class: "material-symbols-outlined !text-[16px] align-middle mr-2" }, "edit", -1)),
                  _createTextVNode(" " + _toDisplayString($setup.directT('contacts.edit')), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.closeViewPopup && $setup.closeViewPopup(...args))),
                  class: "px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 hover:shadow-md",
                  style: {"background-color":"#ffffff","color":"#6b7280","border":"1px solid #e5e7eb"},
                  onMouseover: _cache[15] || (_cache[15] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#f9fafb')),
                  onMouseleave: _cache[16] || (_cache[16] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#ffffff'))
                }, _toDisplayString($setup.directT('contacts.close')), 33)
              ])
            ], 2)
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    ($setup.showAddModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["add-contact-modal fixed inset-0 z-[10000]", $setup.isMobile ? 'top-[80px]' : 'flex items-center justify-center p-4'])
        }, [
          _createElementVNode("div", {
            class: "absolute inset-0 bg-black/40 backdrop-blur-sm",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => ($setup.closeAddContactModal && $setup.closeAddContactModal(...args)))
          }),
          _createElementVNode("div", {
            class: _normalizeClass(["relative transform transition-all duration-300 scale-100 opacity-100", $setup.isMobile ? 'w-full h-full' : 'w-full max-w-lg'])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal-content overflow-hidden", $setup.isMobile ? 'h-full flex flex-col rounded-3xl bg-white dark:bg-[#1c1c1e]' : 'bg-white dark:bg-[#1c1c1e] rounded-3xl shadow-2xl'])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["relative px-6 py-5", $setup.isMobile ? 'rounded-t-3xl' : '']),
                style: {"background":"linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)"}
              }, [
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", _hoisted_87, [
                    _cache[62] || (_cache[62] = _createElementVNode("div", { class: "w-10 h-10 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-[24px] text-white" }, " person_add ")
                    ], -1)),
                    _createElementVNode("h2", _hoisted_88, _toDisplayString($setup.directT('contacts.addNewContact')), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => ($setup.closeAddContactModal && $setup.closeAddContactModal(...args))),
                    class: "w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 transition-all duration-200 flex items-center justify-center group",
                    style: {"border":"none","cursor":"pointer"}
                  }, _cache[63] || (_cache[63] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-white group-hover:rotate-90 transition-transform duration-200" }, " close ", -1)
                  ]))
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["px-6 py-6 space-y-5 custom-scrollbar", $setup.isMobile ? 'flex-1 overflow-y-auto' : 'max-h-[60vh] overflow-y-auto'])
              }, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("label", _hoisted_90, [
                    _cache[64] || (_cache[64] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "person", -1)),
                    _createTextVNode(" " + _toDisplayString($setup.directT('contacts.name')), 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.newContact.name) = $event)),
                    placeholder: $setup.directT('common.name'),
                    class: "w-full px-4 py-3 rounded-xl border-2 text-sm transition-all duration-200 focus:ring-4 focus:ring-purple-500/20 outline-none bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white border-gray-200 dark:border-gray-600 focus:border-purple-500 dark:focus:border-purple-400"
                  }, null, 8, _hoisted_91), [
                    [_vModelText, $setup.newContact.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("label", _hoisted_93, [
                    _cache[65] || (_cache[65] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "phone", -1)),
                    _createTextVNode(" " + _toDisplayString($setup.directT('contacts.phone')), 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.newContact.phone) = $event)),
                    placeholder: $setup.directT('common.phone'),
                    class: "w-full px-4 py-3 rounded-xl border-2 text-sm transition-all duration-200 focus:ring-4 focus:ring-purple-500/20 outline-none bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white border-gray-200 dark:border-gray-600 focus:border-purple-500 dark:focus:border-purple-400"
                  }, null, 8, _hoisted_94), [
                    [_vModelText, $setup.newContact.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("label", _hoisted_96, [
                    _cache[66] || (_cache[66] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "toggle_on", -1)),
                    _createTextVNode(" " + _toDisplayString($setup.directT('contacts.status')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_97, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.newContact.status) = $event)),
                      class: "w-full px-4 py-3 rounded-xl border-2 text-sm transition-all duration-200 focus:ring-4 focus:ring-purple-500/20 outline-none appearance-none bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white border-gray-200 dark:border-gray-600 focus:border-purple-500 dark:focus:border-purple-400"
                    }, [
                      _createElementVNode("option", _hoisted_98, _toDisplayString($setup.directT('contacts.active')), 1),
                      _createElementVNode("option", _hoisted_99, _toDisplayString($setup.directT('contacts.deactive')), 1)
                    ], 512), [
                      [_vModelSelect, $setup.newContact.status]
                    ]),
                    _cache[67] || (_cache[67] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 dark:text-gray-500" }, " expand_more ", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("label", _hoisted_101, [
                    _cache[68] || (_cache[68] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "image", -1)),
                    _createTextVNode(" " + _toDisplayString($setup.directT('contacts.profilePicture') || 'Profile Picture URL'), 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "url",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.newContact.profile_picture_link) = $event)),
                    placeholder: "https://example.com/image.jpg",
                    class: "w-full px-4 py-3 rounded-xl border-2 text-sm transition-all duration-200 focus:ring-4 focus:ring-purple-500/20 outline-none bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white border-gray-200 dark:border-gray-600 focus:border-purple-500 dark:focus:border-purple-400"
                  }, null, 512), [
                    [_vModelText, $setup.newContact.profile_picture_link]
                  ])
                ])
              ], 2),
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => ($setup.closeAddContactModal && $setup.closeAddContactModal(...args))),
                  class: "px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 hover:shadow-md",
                  style: {"background-color":"#ffffff","color":"#6b7280","border":"1px solid #e5e7eb"},
                  onMouseover: _cache[24] || (_cache[24] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#f9fafb')),
                  onMouseleave: _cache[25] || (_cache[25] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#ffffff'))
                }, _toDisplayString($setup.directT('contacts.cancel')), 33),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => ($setup.saveContact && $setup.saveContact(...args))),
                  disabled: $setup.saving,
                  class: "px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed",
                  style: {"background":"linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)","color":"#ffffff"}
                }, [
                  (!$setup.saving)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_104, _toDisplayString($setup.directT('contacts.create')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_105, [
                        _cache[69] || (_cache[69] = _createElementVNode("div", { class: "w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString($setup.directT('common.saving') || 'Saving...'), 1)
                      ]))
                ], 8, _hoisted_103)
              ])
            ], 2)
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    ($setup.showEditModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["edit-contact-modal fixed inset-0 z-[10000]", $setup.isMobile ? 'top-[80px]' : 'flex items-center justify-center p-4'])
        }, [
          _createElementVNode("div", {
            class: "absolute inset-0 bg-black/40 backdrop-blur-sm",
            onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => ($setup.closeEditModal && $setup.closeEditModal(...args)))
          }),
          _createElementVNode("div", {
            class: _normalizeClass(["relative transform transition-all duration-300 scale-100 opacity-100", $setup.isMobile ? 'w-full h-full' : 'w-full max-w-lg'])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal-content overflow-hidden", $setup.isMobile ? 'h-full flex flex-col rounded-3xl bg-white dark:bg-[#1c1c1e]' : 'bg-white dark:bg-[#1c1c1e] rounded-3xl shadow-2xl'])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["relative px-6 py-5", $setup.isMobile ? 'rounded-t-3xl' : '']),
                style: {"background":"linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"}
              }, [
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("div", _hoisted_107, [
                    _cache[70] || (_cache[70] = _createElementVNode("div", { class: "w-10 h-10 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-[24px] text-white" }, " edit ")
                    ], -1)),
                    _createElementVNode("h2", _hoisted_108, _toDisplayString($setup.directT('contacts.editContact') || 'Edit Contact'), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => ($setup.closeEditModal && $setup.closeEditModal(...args))),
                    class: "w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 transition-all duration-200 flex items-center justify-center group",
                    style: {"border":"none","cursor":"pointer"}
                  }, _cache[71] || (_cache[71] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-white group-hover:rotate-90 transition-transform duration-200" }, " close ", -1)
                  ]))
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["px-6 py-6 space-y-5 custom-scrollbar", $setup.isMobile ? 'flex-1 overflow-y-auto' : 'max-h-[60vh] overflow-y-auto'])
              }, [
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("label", _hoisted_110, [
                    _cache[72] || (_cache[72] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "person", -1)),
                    _createTextVNode(" " + _toDisplayString($setup.directT('contacts.name')), 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.editingContact.name) = $event)),
                    placeholder: $setup.directT('common.name'),
                    class: "w-full px-4 py-3 rounded-xl border-2 text-sm transition-all duration-200 focus:ring-4 focus:ring-purple-500/20 outline-none bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white border-gray-200 dark:border-gray-600 focus:border-purple-500 dark:focus:border-purple-400"
                  }, null, 8, _hoisted_111), [
                    [_vModelText, $setup.editingContact.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_112, [
                  _createElementVNode("label", _hoisted_113, [
                    _cache[73] || (_cache[73] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "phone", -1)),
                    _createTextVNode(" " + _toDisplayString($setup.directT('contacts.phone')), 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.editingContact.phone) = $event)),
                    placeholder: $setup.directT('common.phone'),
                    class: "w-full px-4 py-3 rounded-xl border-2 text-sm transition-all duration-200 focus:ring-4 focus:ring-purple-500/20 outline-none bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white border-gray-200 dark:border-gray-600 focus:border-purple-500 dark:focus:border-purple-400"
                  }, null, 8, _hoisted_114), [
                    [_vModelText, $setup.editingContact.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("label", _hoisted_116, [
                    _cache[74] || (_cache[74] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "toggle_on", -1)),
                    _createTextVNode(" " + _toDisplayString($setup.directT('contacts.status')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.editingContact.status) = $event)),
                      class: "w-full px-4 py-3 rounded-xl border-2 text-sm transition-all duration-200 focus:ring-4 focus:ring-purple-500/20 outline-none appearance-none bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white border-gray-200 dark:border-gray-600 focus:border-purple-500 dark:focus:border-purple-400"
                    }, [
                      _createElementVNode("option", _hoisted_118, _toDisplayString($setup.directT('contacts.active')), 1),
                      _createElementVNode("option", _hoisted_119, _toDisplayString($setup.directT('contacts.deactive')), 1)
                    ], 512), [
                      [_vModelSelect, $setup.editingContact.status]
                    ]),
                    _cache[75] || (_cache[75] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 dark:text-gray-500" }, " expand_more ", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("label", _hoisted_121, [
                    _cache[76] || (_cache[76] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-purple-600 dark:text-purple-400" }, "image", -1)),
                    _createTextVNode(" " + _toDisplayString($setup.directT('contacts.profilePicture') || 'Profile Picture URL'), 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "url",
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($setup.editingContact.profile_picture_link) = $event)),
                    placeholder: "https://example.com/image.jpg",
                    class: "w-full px-4 py-3 rounded-xl border-2 text-sm transition-all duration-200 focus:ring-4 focus:ring-purple-500/20 outline-none bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white border-gray-200 dark:border-gray-600 focus:border-purple-500 dark:focus:border-purple-400"
                  }, null, 512), [
                    [_vModelText, $setup.editingContact.profile_picture_link]
                  ])
                ])
              ], 2),
              _createElementVNode("div", _hoisted_122, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => ($setup.closeEditModal && $setup.closeEditModal(...args))),
                  class: "px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 hover:shadow-md",
                  style: {"background-color":"#ffffff","color":"#6b7280","border":"1px solid #e5e7eb"},
                  onMouseover: _cache[34] || (_cache[34] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#f9fafb')),
                  onMouseleave: _cache[35] || (_cache[35] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#ffffff'))
                }, _toDisplayString($setup.directT('contacts.cancel')), 33),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => ($setup.updateContact && $setup.updateContact(...args))),
                  disabled: $setup.saving,
                  class: "px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed",
                  style: {"background":"linear-gradient(135deg, #f093fb 0%, #f5576c 100%)","color":"#ffffff"}
                }, [
                  (!$setup.saving)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_124, _toDisplayString($setup.directT('contacts.update') || 'Update'), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_125, [
                        _cache[77] || (_cache[77] = _createElementVNode("div", { class: "w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString($setup.directT('common.saving') || 'Saving...'), 1)
                      ]))
                ], 8, _hoisted_123)
              ])
            ], 2)
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    ($setup.showDeleteModal && $setup.deletingContact)
      ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
          _createElementVNode("div", {
            class: "absolute inset-0 bg-black/40 backdrop-blur-sm",
            onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => ($setup.closeDeleteModal && $setup.closeDeleteModal(...args)))
          }),
          _createElementVNode("div", _hoisted_127, [
            _createElementVNode("div", _hoisted_128, [
              _createElementVNode("div", _hoisted_129, [
                _createElementVNode("div", _hoisted_130, [
                  _createElementVNode("div", _hoisted_131, [
                    _cache[78] || (_cache[78] = _createElementVNode("div", { class: "w-10 h-10 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-[24px] text-white" }, " delete_forever ")
                    ], -1)),
                    _createElementVNode("h2", _hoisted_132, _toDisplayString($setup.directT('contacts.deleteContact') || 'Delete Contact'), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => ($setup.closeDeleteModal && $setup.closeDeleteModal(...args))),
                    class: "w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 transition-all duration-200 flex items-center justify-center group border-none cursor-pointer"
                  }, _cache[79] || (_cache[79] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-white group-hover:rotate-90 transition-transform duration-200" }, " close ", -1)
                  ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_133, [
                _cache[80] || (_cache[80] = _createElementVNode("div", { class: "w-16 h-16 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center mx-auto mb-6" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-[32px] text-red-500" }, " warning ")
                ], -1)),
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("p", _hoisted_135, _toDisplayString($setup.directT('contacts.deleteConfirmation') || 'Are you sure you want to delete this contact?'), 1),
                  _createElementVNode("p", _hoisted_136, _toDisplayString($setup.deletingContact.name), 1),
                  _createElementVNode("p", _hoisted_137, _toDisplayString($setup.directT('contacts.deleteWarning') || 'This action cannot be undone'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_138, [
                _createElementVNode("button", {
                  onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => ($setup.closeDeleteModal && $setup.closeDeleteModal(...args))),
                  class: "px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600"
                }, _toDisplayString($setup.directT('contacts.cancel') || 'Cancel'), 1),
                _createElementVNode("button", {
                  onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => ($setup.confirmDelete && $setup.confirmDelete(...args))),
                  disabled: $setup.deleteLoading,
                  class: "px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed",
                  style: {"background-color":"#ef4444","color":"#ffffff"},
                  onMouseover: _cache[41] || (_cache[41] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#dc2626')),
                  onMouseleave: _cache[42] || (_cache[42] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#ef4444'))
                }, [
                  ($setup.deleteLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_140))
                    : (_openBlock(), _createElementBlock("span", _hoisted_141, [
                        _cache[81] || (_cache[81] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, "delete", -1)),
                        _createTextVNode(" " + _toDisplayString($setup.directT('contacts.delete') || 'Delete'), 1)
                      ]))
                ], 40, _hoisted_139)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}